import { NgModule } from '@angular/core';
import { AsteriskPipe } from './asterisk.pipe';
import { BracketsPipe } from './brackets.pipe';
import { ColonPipe } from './colon.pipe';
import { ParenthesesPipe } from './parentheses.pipe';

@NgModule({
    declarations: [BracketsPipe, ColonPipe, ParenthesesPipe, AsteriskPipe],
    imports: [],
    exports: [BracketsPipe, ColonPipe, ParenthesesPipe, AsteriskPipe]
})
export class PunctuationModule {}
